import moment from 'moment';
import React from 'react';

import {
    Button, Modal,
    Select,
    message
} from 'antd';

import { API_ENDPOINT, MKT_BASE_CURRENCY } from '../../index';
import { _downloadJobPdfs } from "../../services"

const { DELIVERY_MODES_PRETTY } = require('./config');

const { Option } = Select;

class DownloadDoModal extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            selectedDeliveryMode: false
        }
    }

    async handleDownloadJobPdf() {

        message.loading("Downloading")

        const xhr = await _downloadJobPdfs({
            date: moment(this.props.date).format('YYYY-MM-DD'), 
            deliveryMode: this.state.selectedDeliveryMode,
            locationActionRequired: this.props.locationActionRequired, 
            selectedLocations: this.props.selectedLocations
        })

        function _arrayBufferToString( buffer ) {
            var enc = new TextDecoder("utf-8");
            return enc.decode(buffer);
        }

        const msg = _arrayBufferToString(xhr.data)
        if (msg === `{"message":"No pickup for this date"}`) {
            message.destroy()
            message.success("No jobs for this date")
            return;
        }

        const url = window.URL.createObjectURL(new Blob([xhr.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'file.pdf'); //or any other extension
        document.body.appendChild(link);
        link.click();
        message.destroy()
        message.success("Download Complete")
    }

    render() {

        let fileType = this.props.locationActionRequired === 'delivery' ? 'DO': 'PL'

        return (
            <Modal
                title={`Download ${fileType} PDF for Delivery Mode`}
                onCancel={this.props.onCancel}
                centered
                visible={this.props.visible}
                footer={null}
            >
                <div>
                    <Select style={{ width: 250 }} onChange={(e) => this.setState({ selectedDeliveryMode: e }) }>
                        {Object.keys(DELIVERY_MODES_PRETTY)
                        .filter(_key => !['janio','lalamove'].includes(_key))
                        .map(_key => {
                            return (
                                <Option value={_key}>{DELIVERY_MODES_PRETTY[_key]}</Option>
                            )
                        })}
                    </Select>

                    <Button
                        disabled={!this.state.selectedDeliveryMode}
                        size='large'
                        type='primary'
                        style={{
                            margin: '10px'
                        }}
                        icon='file-excel'
                        // onClick={() => this.handleDownloadJobPdf()}
                        target={`/${this.state.selectedDeliveryMode}-DO-${moment(this.props.date).format('YYYY-MM-DD')}`} 
                        href={`${API_ENDPOINT}/api/admin/delivery/do-v2/${moment(this.props.date).format('YYYY-MM-DD')}?deliveryMode=${this.state.selectedDeliveryMode}&mktBaseCurrency=${MKT_BASE_CURRENCY}&locationActionRequired=${this.props.locationActionRequired}`}
                    >
                        Download
                    </Button>

                </div>

            </Modal>
        )
    }

}

export default DownloadDoModal


// WEBPACK FOOTER //
// ./src/components/delivery-page/download-do-modal.js